/* eslint-disable max-len */
import styled, { css } from 'styled-components';

import { colours } from 'themes/default';

const StyledSelect = styled.select`
  width: 100%;
  appearance: none;
  line-height: 18px;
  color: ${colours.Shades.BlueShade40};
  border-color: ${colours.Greyscale.SilverGrey};
  border-radius: 0.25rem;
  padding: 0.6em 1.4em 0.5em 0.8em;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' aria-hidden='true' focusable='false' width='1em' height='1em' style='-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);' preserveAspectRatio='xMidYMid meet' viewBox='0 0 1200 1200'%3E%3Cpath d='M600.006 989.352l178.709-178.709L1200 389.357l-178.732-178.709L600.006 631.91L178.721 210.648L0 389.369l421.262 421.262l178.721 178.721h.023z' fill='%234C939D'/%3E%3C/svg%3E");
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
  background-color: ${colours.Greyscale.White};

  &:disabled {
    background-color: ${colours.Greyscale.MistGrey};
  }

  &:focus {
    box-shadow: 0 0 0 1px ${colours.Shades.BlueShade40};
    outline: none;
  }

  & > option:hover {
    background: red !important;
  }

  ${({ validationState }) => {
    if (validationState === 'error') {
      return css`
        border-color: ${colours.Messaging.ErrorRed};
        &:focus {
          box-shadow: 0 0 0 3px ${colours.Messaging.ErrorRed};
        }
      `;
    }

    if (validationState === 'warning') {
      return css`
        border-color: ${colours.Messaging.ErrorRed};
        &:focus {
          box-shadow: 0 0 0 3px ${colours.Messaging.ErrorRed};
        }
      `;
    }

    return null;
  }};
`;

export default StyledSelect;
